import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import UserModule from './modules/user';
import FiltersModule from './modules/filters';
import DataModule from './modules/data';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
    key: process.env.VUE_APP_LOCALSTORAGE_KEY,
    storage: window.localStorage,
    reducer: (state) => ({
        user: {
            token: state.user.token,
            id: state.user.id,
            first: state.user.first,
            last: state.user.last,
            permissions: state.user.permissions,
            sections: state.user.sections,
            menu: state.user.menu,
            emailProvider: state.user.emailProvider,
            nimdarepus: state.user.nimdarepus
        },
        redirect: state.redirect,
        filters: state.filters,
        options: state.options,
        data: state.data,
        mobileSidebarVisible: state.mobileSidebarVisible
    })
})

export default new Vuex.Store({
    modules: {
        user: UserModule,
        filters: FiltersModule,
        data: DataModule
    },
    state: {
        backdrop: {
            open: false,
            message: "Saving..."
        },
        mobileSidebarVisible: false,
        modalOpen: false,
        redirect: null
    },
    mutations: {
        TOGGLE_BACKDROP (state, payload){
            if (payload.open === false || payload.open === true){
                state.backdrop.open = payload.open;
            } else {
                state.backdrop.open = !state.backdrop.open;
            }

            if (state.backdrop.open){
                document.body.className = 'overflow-hidden';
            } else {
                document.body.className = '';
            }
        },
        TOGGLE_MODAL (state, payload){
            if (payload.open === false || payload.open === true){
                state.modalOpen = payload.open;
            } else {
                state.modalOpen = !state.modalOpen;
            }
        },
        SET_REDIRECT (state, payload){
            state.redirect = payload;
        },
        TOGGLE_MOBILE_SIDEBAR (state){
            state.mobileSidebarVisible = !state.mobileSidebarVisible;
        },
        CLEAR_CACHE: (state) => {
            state.user.permissions = [];
            state.user.groups = [];
            state.user.sections = [];
            state.user.menu = [];
            state.options = {};
            state.data = {
                typeGroups: [],
                groups: [],
                memberTypes: [],
                groupTypes: [],
                permissionTypes: [],
                suppliers: [],
                forms: [],
                genderTypes: [],
                applicationStatuses: [],
                fasApplicationStatuses: [],
                supplierStatuses: [],
                supplierTypes: [],
                supplierAccountTypes: [],
                states: [],
                templateTypes: [],
                systemUsers: [],
                taskTypes: [],
                taskStatuses: [],
                taskPriorities: [],
            }
        }
    },
    getters: {
        isAppLocked: state => {
            return state.appLocked;
        },
        isBackdropVisible: state => {
            return state.backdrop.open;
        },
        backdropMessage: state => {
            return state.backdrop.message;
        },
        isModalOpen: state => {
            return state.modalOpen;
        },
        redirect: state => {
            return state.redirect;
        },
        user: state => {
            return state.user;
        },
        isMobileSidebarVisible: state => {
            return state.mobileSidebarVisible;
        }
    },
    actions: {
        CLEAR_CACHE (state){

        }
    },
    plugins: [
        vuexLocal.plugin
    ]
});
